import { Button, Popover } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface button {
  onClick: any;
}

const PrintButton = ({ onClick }: button) => {
  const [t] = useTranslation("common");
  const content = <div>{t("print")}</div>;

  return (
    <>
      <Popover content={content} mouseEnterDelay={0} mouseLeaveDelay={0}>
        <Button
          className="Button"
          type="text"
          icon={
            <PrinterOutlined style={{ color: "#212121", fontSize: "14px" }} />
          }
          onClick={onClick}
          size={"small"}
        />
      </Popover>
    </>
  );
};

export default PrintButton;
